import React from 'react';
import './loadingPanel.scss';

const LoadingPanel = props => {
	const {hide} = props;
	return <div className="loadingPanel" style={{backgroundColor: hide ? '#d3e1ed' : '#0000004d'}}>
		<div className="loader" />
	</div>;
};

export default LoadingPanel;
